import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CHAT_ONBOARDING_COOKIE_NAME_MAP } from '../../../constants/chatOnboarding';
import { getBuilderChatButtonClicked } from '../../../selectors/builderChat';
import { selectChatOnboarding } from '../../../selectors/chatOnboarding';
import { TChatOnboardingType } from '../../../types/chatOnboarding';
import { setChatOnboardingCookie } from '../utils/chatOnboardingCookie';
import { setChatOnboardingUnavailable } from '../../../slices/chatOnboarding';

interface IOnboardingTooltipResult {
  open: boolean;
  onboardingText: string;
  closeHandler: () => void;
}

export const useChatOnboarding = (onboardingType: TChatOnboardingType): IOnboardingTooltipResult => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();

  const isBuilderChatButtonClicked = useSelector(getBuilderChatButtonClicked);
  const chatOnboarding = useSelector(selectChatOnboarding);

  const cookieName = CHAT_ONBOARDING_COOKIE_NAME_MAP[onboardingType];
  const available = chatOnboarding[onboardingType].available;
  const onboardingText = chatOnboarding[onboardingType].onboardingText;

  const closeHandler = useCallback(() => {
    setOpen(false);
    dispatch(setChatOnboardingUnavailable(onboardingType));
  }, [dispatch, onboardingType]);

  useEffect(() => {
    setOpen(available);

    if (available) {
      setChatOnboardingCookie(cookieName);
    }
  }, [cookieName, onboardingType, available]);

  useEffect(() => {
    if (onboardingType === 'builder' && open && isBuilderChatButtonClicked) {
      closeHandler();
    }
  }, [isBuilderChatButtonClicked, open, onboardingType, closeHandler]);

  return {
    open,
    onboardingText,
    closeHandler,
  };
};
